import { Hint } from '@/Ship/Components/Hint'
import { formTemplateWithBlocks } from '@/Ship/Templates/Form/formTemplateWithBlocks'

/**
 * Підказка про печатку у формі юрособи, над полем печатки (`SPEC-007` §12,
 * `settings.legal-entities.stamp`).
 *
 * «2000» — межа профілю стиснення `ImageProfile::Setting` на беку; пару тримає
 * вартовий «числа в підказках збігаються з константами беку».
 */
export const LegalEntityStampHint = () => (
    <Hint id="settings.legal-entities.stamp">
        Печатка — лише PNG; зображення, більші за 2000 px за довшою стороною, зменшуються. У документ вона
        потрапляє, якщо в шаблоні є змінна печатки, а під час генерації увімкнено «З печаткою та підписом».
    </Hint>
)

/** Форма юрособи: ядрова форма + підказка над полем печатки. */
export const legalEntityFormTemplate = formTemplateWithBlocks({ stamp: LegalEntityStampHint })
